import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=ac40fb4a&scoped=true&"
import script from "./Test.vue?vue&type=script&lang=tsx&"
export * from "./Test.vue?vue&type=script&lang=tsx&"
import style0 from "./Test.vue?vue&type=style&index=0&id=ac40fb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac40fb4a",
  null
  
)

export default component.exports